import onboarding from "./onboarding"
import activities from "./activities"
import productTour from "./product-tour"
import { global } from "./global"

const mixpanelClient = {
  onboarding,
  productTour,
  activities,
  global,
}

export default mixpanelClient
